import { State } from 'flow/types/State';
import { convertNumberToE164 } from 'flow/utils/call-utils';

export const selectCentionDeeplinkForCallWithCallerNumber = (
    state: State,
    callerNumber: string,
) =>
    state.omnichannel.getIn([
        'deeplinkPerCallerId',
        convertNumberToE164(callerNumber),
    ]);
